module.exports = __webpack_public_path__ + "img/bg5.0b37f7db.jpg";